





import {Vue,Component,Prop} from 'vue-property-decorator';
import {Line} from '../DependencyGraphContainer.vue';
import store from '@/store';

@Component
export default class DependencyGraphEdg extends Vue{
    @Prop() line?: Line;
  
    
    
    get length(){
        if(!this.line)
        return 0;

        const a = this.line.end.x - this.line.start.x;
        const b = this.line.end.y - this.line.start.y;
        const length =  Math.sqrt( Math.pow(a,2) + Math.pow(b,2));
        return length;
    }
    
    get angle(){
        if(!this.line)
             return 0;
        const y = this.line.end.y - this.line.start.y;
        const x = this.line.end.x - this.line.start.x;
        const r = this.length;
        const ratioY =  y*1.0/r;
        const ratioX =  x*1.0/r;
        const radianY = Math.asin(ratioY);
        const radianX = Math.acos(ratioY);
        const pi = Math.PI;
        const angleY = radianY * 180/pi;
        const angleX = radianX * 180/pi;
        
        
         if(x<0) return angleX + 90;
        return angleY;
    }
}
